import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { getAxiosImportServer } from "../../shared/Services/importService";
import { IMPORT_GET_SPORT, IMPORT_SPORT } from "../../utils/api/ApiConstant";
import { DataTable, Filter, SubHeading, Switch } from "../../shared/Components";
import { postAxios } from "../../shared/Services/commonService";
import showToast from "../../utils/toastUtil";

const Import = () => {
  const navigate = useNavigate();
  const [selectedItems, setSelectedItems] = useState({});
  const [filterParams, setFilterParams] = useState({
    event: 1,
  });

  const handleFilterParams = (values) => {
    setFilterParams({
      event: values?.event?.value || null,
    });
    setSelectedItems({});
  };

  const { isLoading, data, refetch } = useQuery({
    queryKey: ["importSportData", filterParams],
    queryFn: async () =>
      await getAxiosImportServer(
        `${IMPORT_GET_SPORT}/${filterParams.event}`,
        {},
      ),
  });

  const handleSwitchToggle = (row) => {
    setSelectedItems((prev) => ({
      ...prev,
      [row.id]: !prev[row.id],
    }));
  };

  const handleImport = async () => {
    const selectedIds = Object.keys(selectedItems)
      .filter((id) => selectedItems[id])
      .map((id) => String(id));

    if (selectedIds.length === 0) {
      showToast.info("Please select at least one item to import");
      return;
    }

    try {
      const response = await postAxios(
        `${IMPORT_SPORT}/${filterParams.event}`,
        {
          id: selectedIds,
        },
      );

      setSelectedItems({});
      refetch();
    } catch (error) {
      console.error("Import failed", error);
    }
  };

  const fetchData = () => {
    if (!data) return { data: [], pages: 0 };

    return {
      data: data?.data,
      pages: data?.pages,
    };
  };

  const columns = [
    {
      accessorKey: "name",
      header: "Name",
      cell: ({ getValue, row }) => {
        return (
          <span
            onClick={() =>
              navigate(
                `/config/import2/${filterParams.event}/${row?.original?.id}`,
                {
                  state: {
                    sport: row?.original,
                    source: filterParams.event,
                  },
                },
              )
            }
            className="cursor-pointer"
          >
            {getValue()}
          </span>
        );
      },
    },
    {
      accessorKey: "exists",
      header: "Import",
      cell: ({ getValue, row }) => {
        const exists = getValue();
        const isSelected = selectedItems[row.original.id] || false;

        return (
          <Switch
            getValue={() => (exists ? true : isSelected)}
            disabled={exists}
            onChange={() => !exists && handleSwitchToggle(row.original)}
          />
        );
      },
    },
  ];

  return (
    <>
      <SubHeading
        subTitle="Game Import"
        isAddBtnPage={false}
        isAddBtn={false}
        redirectPath="create"
        isImport={true}
        onClick={handleImport}
      />
      <Filter isEvent={true} handleFilterParams={handleFilterParams} />
      <div className="card-body">
        <DataTable
          columns={columns}
          data={data?.data}
          isSearchable={false}
          isPagination={false}
          isPageSize={false}
          // currentPage={currentPage}
          // onPageChange={handlePageChange}
          // onRecordsPerPageChange={handleRecordsperPage}
          // recordsPerPage={recordsPerPage}
          // onSearchChange={handleSearch}
          // searchTerm={searchTerm}
          isLoading={isLoading}
          // handleHeaderSort={handleHeaderSort}
        />
      </div>
    </>
  );
};

export default Import;
